import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import { Box } from "@material-ui/core";
import { TemplateProps } from "../../journeys/journey/Interfaces";
import { Spinner } from "ams-ui-reactkit";
import { navigate, useLocation } from "@reach/router";
import { useContextSelector } from "@fluentui/react-context-selector";
import { StoreContext } from "../../context";
import actionTypeConstants from "../../utils/actionTypeConstants";
import {
  getEnvVariable,
  getJourneyFileName,
  getMobileOperatingSystem,
} from "../../utils/helpers";
import Journey from "../../journeys/journey/Journey";
import Header from "../../organisms/Header/Header";
import { isEmpty } from "lodash";

const Layout: React.FC<TemplateProps> = (props: any) => {
  const [journeytemplate, setjourneytemplate] = useState<any>();
  //let journeyType = getEnvVariable('JOURNEY_TYPE')
  const location = useLocation();
  const search = new URLSearchParams(location.search);
  const boxRef = useRef(null);

  const uiState: any = useContextSelector(
    StoreContext,
    (store) => store?.appState?.ui
  );

  const customerContext: any = useContextSelector(
    StoreContext,
    (store) => store?.appState?.customerJourneyContext
  );

  const jourenyInfo: any = useContextSelector(
    StoreContext,
    (store) => store?.appState?.jourenyInfo
  );

  const dispatch: any = useContextSelector(
    StoreContext,
    (store) => store?.dispatch
  );

  const getSubpath = (url: any) => {
    const pathSegments = new URL(url).pathname
      .split("/")
      .filter((segment) => segment !== "");
    return pathSegments[pathSegments.length - 1];
  };

  const currentUrl = window.location.href;
  let subPath = getSubpath(currentUrl);

  const getTemplateFromLocal = () => {
    const journeyFile = require(`../../journeys/journey/inventory.json`);

    if (journeyFile) {
      setjourneytemplate(journeyFile);
    }
  };

  useEffect(() => {
    getTemplateFromLocal();
  }, []);

//   useEffect(() => {
//     console.log("Customer Page : ", customerContext);

//     let notRedirectedSubPath = [
//       "home",
//       "affirmCancellation",
//       "affirmThankyou",
//       "affirm-checkout",
//       "payment",
//       "confirmation",
//       "rooms",
//       "yembo-thankyou",
//       "moveitems",
//       "moveinfo",
//     ];

//     let isSubPathRedirect = notRedirectedSubPath?.includes(`${subPath}`);
//     if (isEmpty(customerContext) && !isSubPathRedirect) {
//       let custToken = sessionStorage?.getItem("custToken");
//       let journeyName = sessionStorage?.getItem("journey");

//       window.location.href = `/home?journey=${journeyName}&custToken=${custToken}`;
//     }
//   }, [customerContext]);

  useEffect(() => {
    const pageCount =
      journeytemplate && Object.keys(journeytemplate?.pages)?.length - 1;

    dispatch({
      type: actionTypeConstants.UPDATE_PAGE_COUNT,
      payload: {
        noOfPagesInJourney: pageCount || 0,
      },
    });
  }, [journeytemplate]);

  const isBackNav = () => {
    if (uiState?.showBackLink === "hide") {
      return false;
    }
    if (uiState?.showBackLink === "show") {
      return true;
    }

    //historyIndex is 0 index variable here so noOfPagesInJourney -1
    if (
      uiState?.historyIndex &&
      uiState?.historyIndex < jourenyInfo?.noOfPagesInJourney - 1
    ) {
      return true;
    }
    return false;
  };

  const showProgress = () => {
    let pages = jourenyInfo?.noOfPagesInJourney || 0;
    const idx: any = uiState?.historyIndex || 0;
    //pages = pages + 1;

    const progressValue = uiState?.progressValue;



    if (progressValue && progressValue > 0) {
      //return (idx / (pages -1 )) * 100;
      return progressValue;
    } else {
      return (idx / pages) * 100;
    }
  };

  return (
    <Box>
      <Header backNav={isBackNav()} progressValue={showProgress() || 0} />
      {!journeytemplate ? (
        <Box
          // display="flex"
          // justifyContent="center"
          // alignItems="center"
          // mt={18}
          className="wrapper"
        >
          <Spinner />
        </Box>
      ) : (
        <Box
          // display="flex"
          // justifyContent="center"
          // alignItems="center"
          // mt={18}
          className="wrapper"
        >
          <Journey
            goal={journeytemplate?.goal || {}}
            pages={journeytemplate?.pages || {}}
          />
        </Box>
      )}
    </Box>
  );
};

export default Layout;
